import { useCallback, useState, useReducer, useEffect, useRef } from 'react';

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return {
        ...state,
        isInitialized: true,
        isLoading: true,
        isError: false,
        isNetworkError: false
      };
    case 'FETCH_SUCCESS':
      return {
        isInitialized: true,
        isLoading: false,
        isError: false,
        isNetworkError: false,
        data: action.payload
      };
    case 'FETCH_FAILURE':
      return {
        ...state,
        isLoading: false,
        isError: true,
        isNetworkError: false,
        error: action.payload
      };
    case 'FETCH_NETWORK_FAILURE':
      return {
        ...state,
        isLoading: false,
        isNetworkError: true
      };
    default:
      throw new Error();
  }
};

const useDataApi = (initialService, initialData) => {
  const [service, setServiceVal] = useState(() => initialService);
  const [state, dispatch] = useReducer(dataFetchReducer, {
    data: initialData,
    isInitialized: false,
    isLoading: false,
    isError: false,
    isNetworkError: false,
    error: null
  });

  const dataRef = useRef(initialData);

  const setService = useCallback(newService => {
    setServiceVal(() => newService);
  }, []);

  useEffect(() => {
    let didCancel = false;

    if (service) {
      dispatch({ type: 'FETCH_INIT' });
      console.info('👋 Data fetch started.');

      try {
        service(dataRef?.current).then(
          response => {
            if (!didCancel) {
              // this variable points to the current response
              // we' ll use it for pagination purposes to append to
              // the new responses
              dataRef.current = response;
              dispatch({ type: 'FETCH_SUCCESS', payload: response });
              console.info('👍 Data fetch completed. Here is the data: ', response);
            }
          },
          error => {
            if (!didCancel) {
              console.error('🔥 An error occured while fetching data: ', error);

              if (error.status === -999) {
                dispatch({ type: 'FETCH_NETWORK_FAILURE' });
              } else {
                dispatch({ type: 'FETCH_FAILURE', payload: error });
              }
            }
          }
        );
      } catch (error) {
        console.error('🔥 An error occured while fetching data: ', error);

        if (error.status === -999) {
          dispatch({ type: 'FETCH_NETWORK_FAILURE' });
        } else {
          dispatch({ type: 'FETCH_FAILURE', payload: error });
        }
      }
    }

    return () => {
      didCancel = true;
    };
  }, [service]);

  return [state, setService, dispatch];
};

export default useDataApi;
